import React from 'react';
import styled from 'styled-components';

const BounceLoader = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100px;
  height: 100px;

  div {
    width: 15px;
    height: 15px;
    background-color: #0173C6;
    border-radius: 50%;
    animation: bounce 1.4s infinite ease-in-out both;
  }

  div:nth-child(1) {
    animation-delay: -0.32s;
  }

  div:nth-child(2) {
    animation-delay: -0.16s;
  }

  @keyframes bounce {
    0%, 80%, 100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0px 0px 40px;
`;

const BounceLoaderComponent: React.FC = () => (
  <LoaderContainer>
    <BounceLoader>
      <div />
      <div />
      <div />
    </BounceLoader>
  </LoaderContainer>
);

export default BounceLoaderComponent;